
import * as THREE from 'three';
import gsap from "gsap";
import { setInterval } from 'timers/promises';
import { Point3, Params } from '../../data/Params';
import textA from "../../csv/A1.frag";
import textA2 from "../../csv/A2.frag";

import textM from "../../csv/M.frag";
import textN from "../../csv/N.frag";
import textQ from "../../csv/Q.frag";
import textT from "../../csv/T.frag";
import textU from "../../csv/U.frag";
import textI from "../../csv/I.frag";

import logo1 from "../../csv/logo1.frag";
import logo2 from "../../csv/logo2.frag";
import { MojiDot } from '../MojiDot';


export class MojiPointsUtil{


    public static pointsDict: { [name: string]:Point3[] } = {};
    public static distanceDict: { [name: string]:number } = {};


    static init(){

        MojiPointsUtil.makePoints(Params.MOJI_Q,textQ);
        MojiPointsUtil.makePoints(Params.MOJI_U,textU);
        MojiPointsUtil.makePoints(Params.MOJI_A,textA);
        MojiPointsUtil.makePoints(Params.MOJI_A2,textA2);
        
        MojiPointsUtil.makePoints(Params.MOJI_N,textN);
        MojiPointsUtil.makePoints(Params.MOJI_T,textT);
        MojiPointsUtil.makePoints(Params.MOJI_I,textI);
        MojiPointsUtil.makePoints(Params.MOJI_M,textM);

        MojiPointsUtil.makePoints(Params.MOJI_LOGO1,logo1);
        MojiPointsUtil.makePoints(Params.MOJI_LOGO2,logo2);
        
    }

    //static 
    static getPoints(key:string):Point3[]{
        return MojiPointsUtil.pointsDict[key];
    }

    //文字のポイントだけ返してくれる君
    static makePoints(key:string,text:string,ox:number=0,oy:number=0):Point3[]{

        if(MojiPointsUtil.pointsDict[key]){
            return MojiPointsUtil.pointsDict[key];
        }

        let lines = text.split('\n');
        let list = [];
        for(let i=1;i<lines.length;i++){
            let line = lines[i];
            let values = line.split('\t');

            let xx = (+values[1])+ox;
            let yy = (+values[2])+oy;
            let zz = 0;//Math.random();

            list.push({
                x:xx,y:yy,z:zz
            })
        }

        //loopするように
        list.push(
            {
                x:list[0].x,
                y:list[0].y,
                z:list[0].z                
            }
        );

        MojiPointsUtil.pointsDict[key]=list;

        return list;

    }

    static getPoint(ratio:number, points:Point3[]):Point3{

        let idx1:number = Math.floor( points.length * ratio );
        let idx2:number = idx1 + 1;

        if(ratio==0)return points[idx1];
        if(idx1>=points.length) idx1 = points.length-1;
        if(idx2>=points.length) idx2 = points.length-1;

        let r1 = idx1/points.length;
        let r2 = idx2/points.length;

        if(r1==r2)return points[0];

		let p1 = points[idx1];
		let p2 = points[idx2];

        let r = (ratio - r1) / (r2 - r1);

        let v = {
            x: (1-r)*p1.x+r*p2.x,
            y: (1-r)*p1.y+r*p2.y,
            z: 0//(1-r)*p1.z+r*p2.z,
        }

        if(Number.isNaN(v.x)){
            console.log(points.length,idx1,idx2,r1,r2,r,p1.x,p2.x);
            //169 167 168 0.9881656804733728 0.9940828402366864 0.31000000000010675 -0.351 NaN
        }

        return v;

    }

    static getDistance(key:string,points:Point3[]):number{

        if(MojiPointsUtil.distanceDict[key]){
            return MojiPointsUtil.distanceDict[key];
        }

        let dist:number = 0;
        for(let i=0;i<points.length-1;i++){
            
            let xx1:number = points[i].x;
            let yy1:number = points[i].y;
            let xx2:number = points[i+1].x;
            let yy2:number = points[i+1].y;
            let d1:number = xx2-xx1;
            let d2:number = yy2-yy1;

            dist += Math.sqrt(
                d1*d1+d2*d2
            );

        }

        MojiPointsUtil.distanceDict[key]=dist;

        return dist;

    }

    public static RandomArray( dots:MojiDot[] ):MojiDot[]{

        for(let i=0;i<dots.length;i++){
            let idxA = Math.floor(dots.length*Math.random());
            let idxB = Math.floor(dots.length*Math.random());
            let tmp = dots[idxA];
            dots[idxA] = dots[idxB];
            dots[idxB] = tmp;
        }
        return dots;

    }



}
